import { api, enc } from "@/lib/api";

export const ROLE_LABEL = { recruiter: "Recruiter", hiring_manager: "Hiring manager", leader: "Leader", peer: "Peer" };
export const CONTACT_STATUS = ["to_contact", "contacted", "replied"];
export const STATUS_LABEL = { to_contact: "To contact", contacted: "Contacted", replied: "Replied" };

export const pfPath = ({ company, role, job_id, job_title }) => {
  const q = new URLSearchParams({ company: company || "", run: "1" });
  if (role) q.set("role", role);
  if (job_id) q.set("job_id", job_id);
  if (job_title) q.set("job_title", job_title);
  return `/people-finder?${q}`;
};

export const trackerJobs = (company) => api.get("/people-finder/tracker-jobs", { params: { company } }).then((r) => r.data?.items || []);
export const saveContact = (job_id, person) => api.post("/people-finder/contacts", { job_id, person }).then((r) => r.data);
export const patchContact = (job_id, id, body) => api.patch(`/people-finder/contacts/${enc(job_id)}/${enc(id)}`, body).then((r) => r.data?.contact);
export const deleteContact = (job_id, id) => api.delete(`/people-finder/contacts/${enc(job_id)}/${enc(id)}`);
export const resumeOptions = (job_id) => api.get("/people-finder/resume-options", { params: job_id ? { job_id } : {} }).then((r) => r.data?.options || []);

const SUFFIX = /\b(the|inc|incorporated|llc|ltd|limited|corp|corporation|co|company|plc|gmbh|ag|sa|group|holdings|technologies|technology|labs)\b/g;
const norm = (s) => (s || "").toLowerCase().replace(/&/g, " and ").replace(/[^\p{L}\p{N}\s]/gu, " ").replace(SUFFIX, " ").replace(/\s+/g, " ").trim();
const host = (d) => (d || "").toLowerCase().replace(/^https?:\/\//, "").replace(/^www\./, "").split("/")[0];

// True only when the person's listed company is the searched company (name, or same domain + name contains it).
export const worksAt = (p, company, domain) => {
  const want = norm(company);
  if (!want) return true;
  if (norm(p.company) === want) return true;
  return !!domain && host(p.company_domain) === host(domain) && norm(p.company).includes(want);
};

export const mailto = (to, subject, body) => `mailto:${to || ""}?subject=${encodeURIComponent(subject || "")}&body=${encodeURIComponent(body || "")}`;

// Downloads the chosen resume PDF, then opens a mail draft (web can't attach files to mailto).
export const downloadResume = async (opt) => {
  const { data, headers } = await api.get("/people-finder/resume-file", { params: { source: opt.source, id: opt.id }, responseType: "blob" });
  const m = /filename\*?=(?:UTF-8'')?"?([^";]+)/i.exec(headers?.["content-disposition"] || "");
  const name = m ? decodeURIComponent(m[1]) : `${(opt.label || "resume").replace(/[^\w-]+/g, "-")}.pdf`;
  const a = document.createElement("a");
  a.href = URL.createObjectURL(data);
  a.download = name;
  a.click();
  setTimeout(() => URL.revokeObjectURL(a.href), 4000);
  return name;
};
